import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSelectChange } from '@angular/material/select';
import { BaseComponent } from '../../../base.component';
import { User } from '../../../../models/ui/user.model';
import { AccountManager } from '../../../../managers/account.manager';
import { AccountUserType, AccountUserTypeGuid, AccountUserTypes } from '../../../../models/account-user-type';
import { RoleGuid } from '../../../../models/role.model';
import { orderBy } from 'lodash-es';
import { MatSelectionListChange } from '@angular/material/list';

@Component({
    selector: 'lex-manage-account-roles-dialog',
    templateUrl: './manage-account-roles-dialog.component.html',
    styleUrls: ['./manage-account-roles-dialog.component.scss'],
    standalone: false
})
export class ManageAccountRolesDialogComponent extends BaseComponent {

	public selectedUser: User = null;
	public selectedAccountRoles: string[] = [];
	public selectedAccountName: string = '';
	public formChanged: boolean = false;
	public selection: SelectionModel<string>;
	public selectedUserType: string = '';
	public userTypes: AccountUserType[];
	public userTypeRoles: Record<AccountUserTypeGuid, RoleGuid[]>;
	public roleGuid = RoleGuid;

	private selectedAccountId: string = '';

	constructor(private dialogRef: MatDialogRef<ManageAccountRolesDialogComponent>,
		private accountManager: AccountManager,
		@Inject(MAT_DIALOG_DATA) private data: any) {
		super();
		this.selectedUser = data.selectedUser;
		this.selectedAccountId = data.selectedAccountId;
		this.selectedAccountRoles = data.selectedAccountRoles;
		this.selectedAccountName = this.selectedUser.accounts.find(x => x.accountId === this.selectedAccountId).accountName;
		this.selection = new SelectionModel<string>(true, this.selectedAccountRoles);
		this.userTypes = orderBy(new AccountUserTypes().lookup);
		this.userTypeRoles = new AccountUserTypes().lookupRoles;
		this.lookup();
	}

	public submit(): void {
		this.selectedAccountRoles = this.selection.selected;
		this.dialogRef.close(this.selectedAccountRoles);
	}

	public changeUserType(select: MatSelectChange): void {
		const roleIds = this.userTypeRoles[select.value];
		this.selection.clear();
		this.selection.select(...roleIds);
		if (!this.formChanged)
			this.formChanged = true;
	}

	public changeAccountIds(selection: MatSelectionListChange): void {
		selection.options.forEach((option) => {
			if (option.selected) {
				this.selection.select(option.value);
			} else {
				this.selection.deselect(option.value);
			}
		});
		if (!this.formChanged)
			this.formChanged = true;
		this.lookup();
	}

	private lookup(): void {
		this.selectedUserType = AccountUserTypeGuid.Custom;
		for (const userType in this.userTypeRoles) {
			let match = true;
			if (this.userTypeRoles[userType].length !== this.selection.selected.length)
				match = false;
			else {
				for (const role of this.userTypeRoles[userType]) {
					if (!this.selection.isSelected(role)) {
						match = false;
					}
				}
			}
			if (match) {
				this.selectedUserType = userType;
			}
		}
	}

}
